import { ColumnsType } from 'antd/es/table';
import { t } from 'i18next';
import { getUTCTableDateFormat } from '@/shared/utils';
import { trustedSourceTypeTitles } from '@/stores/TrustedSourceStore/TrustedSourceStore.consts';
import { TrustedSourceActions } from './Actions/Actions';
import { TrustedSourceDto } from '@user1st/api-client';

export interface TrustedSourcesDataType {
  key: string;
  id: string;
  type: string;
  value: string;
  comment?: string;
  expiredAt?: string;
  lastValidatedAt?: string;
  createdAt: string;
  updatedAt: string;
  actions: string;
}

export const getColumns = (): ColumnsType<TrustedSourcesDataType> => [
  {
    title: `${t('admin.table.created_at')} (UTC)`,
    key: 'createdAt',
    render: (item: TrustedSourceDto) => getUTCTableDateFormat(item.createdAt),
  },
  {
    title: t('admin.table.type'),
    key: 'type',
    render: (item: TrustedSourceDto) => trustedSourceTypeTitles[item.type],
  },
  {
    title: t('admin.table.value'),
    dataIndex: 'value',
    key: 'value',
  },
  {
    title: t('admin.form.features'),
    key: 'features',
    render: (item: TrustedSourceDto) =>
      item.features?.map((feature) => feature.code).join(', ') || '-',
  },
  {
    title: t('admin.table.comment'),
    key: 'comment',
    render: (item: TrustedSourceDto) => item.comment || '-',
  },
  {
    title: `${t('admin.table.last_validated_at')} (UTC)`,
    key: 'lastValidatedAt',
    render: (item: TrustedSourceDto) =>
      item.lastValidatedAt ? getUTCTableDateFormat(item.lastValidatedAt) : '-',
  },
  {
    title: `${t('admin.table.expires_at')} (UTC)`,
    key: 'expiredAt',
    render: (item: TrustedSourceDto) =>
      item.expiredAt ? getUTCTableDateFormat(item.expiredAt) : '-',
  },
  {
    key: 'actions',
    render: (item: TrustedSourceDto) => {
      return <TrustedSourceActions item={item} />;
    },
  },
];
